import {
    optionalConnectedExperiencesStatusChanged,
    type OptionalConnectedExperiencesStatusUpdate,
} from '../actions/optionalConnectedExperiencesStatusChanged';
import { addPrivacyDiagnosticEvent } from '../logging/privacyLogging';

let lastValue: boolean | undefined = undefined;

// Normally, Satchel's reactivity system would notify React components when a value changes.
// However, the privacy store is used outside of React components,
// so this listener ensures we can still respond to changes outside the React lifecycle.
export function notifyIfOptionalExperiencesChanged({
    isOceDisabled,
}: OptionalConnectedExperiencesStatusUpdate): void {
    if (lastValue !== undefined && lastValue !== isOceDisabled) {
        optionalConnectedExperiencesStatusChanged({ isOceDisabled });

        addPrivacyDiagnosticEvent('optionalConnectedExperiencesStatusChanged', {
            additionalInfo: { isOceDisabled },
        });
    }

    lastValue = isOceDisabled;
}

// Needed for unit testing
export function resetOptionalExperiencesNotifier(): void {
    lastValue = undefined;
}
